module.exports = __webpack_public_path__ + "img/logo.3822a4bd.png";